export default function Footer() {
  return (
    <footer className="bg-deep-charcoal border-t-2 border-teal/30 py-8 px-6 md:px-12 lg:px-20 relative overflow-hidden">
      {/* Teal glow strip */}
      <div className="absolute top-0 left-1/4 right-1/4 h-px bg-teal/60 blur-sm pointer-events-none" />
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-sans text-xs text-warm-gray/50 tracking-wide">
          &copy; 2026 Jordan Duke. Senior Interior Designer / Project Lead.
        </p>
        <div className="flex items-center gap-5">
          <a
            href="https://www.instagram.com/jcd7/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 flex items-center justify-center text-teal/60 hover:text-teal transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-instagram-line text-base" />
          </a>
          <a
            href="https://www.linkedin.com/in/jordancduke/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 flex items-center justify-center text-teal/60 hover:text-teal transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-linkedin-line text-base" />
          </a>
          <a
            href="mailto:jcd7@att.net"
            className="w-8 h-8 flex items-center justify-center text-teal/60 hover:text-teal transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-mail-line text-base" />
          </a>
        </div>
      </div>
    </footer>
  );
}